/* ––
 * ––– Imports
 * –––––––––––––––––––––––––––––––– */
import PropTypes               from 'prop-types';
import React, { useEffect }   from 'react';
import { Map, Iterable, List } from 'immutable';

import Grid          from '@mui/material/Grid';
import TextField     from '@mui/material/TextField';
import Autocomplete  from '@mui/material/Autocomplete';

/* ––
 * ––– Component
 * –––––––––––––––––––––––––––––––– */
function Dropdown({
  value = null,
  name = null,
  onChange = null,
  dropdownOptions = new List(),
  disabled = false,
  forced = false,
}) {
  const input = value && value.get('value');
  const uniqOptions = [
    ...new Set(
      dropdownOptions.map((option) => option),
    ),
  ];

  useEffect(() => {
    if (forced) {
      onChange(name, new Map({ text: input || t('eos.landing_page.label.no_answer'), forced: true }));
    }
  }, [forced]);

  /* –– Handlers
   * –––––––––––––––––––––––––––––––– */
  function setInput(selectedValue) {
    const chosenValue = selectedValue.currentTarget.textContent;
    if (dropdownOptions.includes(chosenValue)) {
      onChange(name, new Map({ text: chosenValue }));
    } else {
      onChange(name, new Map({ text: '' }));
    }
  }

  /* –– Render
   * –––––––––––––––––––––––––––––––– */
  return (
    <Grid container>
      <Grid item xs={12}>
        <Autocomplete
          data-testid="dropdown"
          options={uniqOptions}
          getOptionLabel={(option) => option.toString()}
          renderInput={(params) => (
            <TextField {...params} placeholder={t('eos.landing_page.text.dropdown_instruction')} />
          )}
          clearOnBlur={false}
          disableCloseOnSelect={false}
          disabled={disabled}
          onChange={(e) => setInput(e)}
          value={input}
        />
      </Grid>
    </Grid>
  );
}

/* ––
 * ––– Props declaration
 * –––––––––––––––––––––––––––––––– */
Dropdown.propTypes = {
  value:           PropTypes.objectOf(Iterable),
  name:            PropTypes.string,
  onChange:        PropTypes.func,
  dropdownOptions: PropTypes.objectOf(Iterable),
  disabled:        PropTypes.bool,
  forced:          PropTypes.bool,
};

/* ––
 * ––– Exports
 * –––––––––––––––––––––––––––––––– */
export default Dropdown;
